/**
 * Footer.tsx — 页脚
 */
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-6 text-sm text-slate-400 sm:flex-row">
        <p>PromptHub · AI 提示词收藏站 — 独立开发者穷鬼套餐（2026）演示项目</p>
        <div className="flex items-center gap-4">
          <Link to="/submit" className="transition hover:text-indigo-600">
            提交 Prompt
          </Link>
          <Link to="/subscribe" className="transition hover:text-indigo-600">
            邮件订阅
          </Link>
          <a
            href="https://github.com/"
            target="_blank"
            rel="noreferrer"
            className="transition hover:text-indigo-600"
          >
            GitHub
          </a>
        </div>
      </div>
    </footer>
  );
}
